import { useQuery } from '@tanstack/react-query';

import progressTrackingService from './progressTrackingService';

import type { ProgressTrackingSummary } from '@/types/cycle-evaluation/ProgressTrackingSummary';

import { CycleEvaluationQueryKey } from '@/constants/QueryKeys';

export const useGetProgressTrackingSummary = () =>
    useQuery<ProgressTrackingSummary>({
        queryKey: [CycleEvaluationQueryKey.PROGRESS_TRACKING_SUMMARY],
        queryFn: () => progressTrackingService.getProgressTrackingSummary(),
    });
